module.exports = __webpack_public_path__ + "web_static/img/the_neighborhood_mobile.1fd1f875.png";